/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React components
import SoftTypography from "components/SoftTypography";

const categoriesListData = [
  {
    color: "dark",
    icon: "play_circle_filled",
    name: "High-Level Overview of Optimind-AI",
    description: (
      <>
        <SoftTypography variant="caption" color="text" fontWeight="medium">
        Step-by-step guide on how to use our platform.
        </SoftTypography>
      </>
    ),
    route: "/Dashboards/Default",
  },
  {
    color: "dark",
    icon: "list",
    name: "Retrieving Patient To-Do Notes",
    description: (
      <>
        <SoftTypography variant="caption" color="text" fontWeight="medium">
          Learn how to stay organized by using our task planner.
        </SoftTypography>
      </>
    ),
    route: "/Dashboards/Default",
  },
  {
    color: "dark",
    icon: "note_alt",
    name: "Importing Templates and Summaries from our Libraries",
    description: (
      <>
        <SoftTypography variant="caption" color="text" fontWeight="medium">
        Learn how to import pre-defined note structures based on your profession.
        </SoftTypography>
      </>
    ),
    route: "/Dashboards/Default",
  },
];

export default categoriesListData;
